import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface ChipOpcionProps {
  activo: boolean;
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
  /** Tipografía monoespaciada — para valores numéricos (años, códigos). */
  mono?: boolean;
}

/**
 * Chip de atajo para un valor ÚNICO: esquina de 8px, sin check, y volver a
 * tocarlo lo deselecciona. Lo usa el campo Tipo de Vehículos y Maquinaria, donde
 * es el CONTROL del campo y no un adorno: elegir de una lista corta sin
 * convertir la columna en un enum que rechace lo ya cargado.
 *
 * No lo uses como sugerencia junto a un campo que ya se puede escribir — los
 * atajos de año salieron por eso: el chip repetía el placeholder del input.
 *
 * NO confundir con `ChipsSeleccion`: aquel es selección MÚLTIPLE, píldora
 * redonda y con check, para conjuntos acotados con conteo (áreas, cargos).
 */
export function ChipOpcion({
  activo,
  onClick,
  disabled,
  children,
  mono = false,
}: ChipOpcionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={activo}
      className={cn(
        "inline-flex h-[30px] shrink-0 items-center gap-1.5 rounded-lg border px-3 text-[12.5px] font-medium whitespace-nowrap transition-colors disabled:pointer-events-none disabled:opacity-50",
        mono && "fc-num",
        activo
          ? "border-primary bg-primary-50 text-primary-hover"
          : "border-input bg-background text-muted-foreground hover:border-primary-border hover:text-foreground",
      )}
    >
      {children}
    </button>
  );
}
